import { safeJsonStringify } from '../../utils/json';

/**
 * serializes page inputs into flattened URL search params
 *
 * first-level properties are added as individual query params
 * - primitives (string, number, boolean) are serialized as-is
 * - objects and arrays are JSON-stringified
 */
export function serializePageInputsToSearchParams(
  pageInputs: Record<string, unknown> | undefined,
): URLSearchParams {
  const searchParams = new URLSearchParams();

  if (!pageInputs) {
    return searchParams;
  }

  for (const [key, value] of Object.entries(pageInputs)) {
    if (value === undefined || value === null) {
      continue;
    }

    if (typeof value === 'object') {
      // for objects and arrays, serialize as JSON
      searchParams.set(key, safeJsonStringify(value, ''));
    } else {
      // for primitives (string, number, boolean), serialize as string
      searchParams.set(key, String(value));
    }
  }

  return searchParams;
}
